export default __webpack_public_path__ + "static/media/eagle.a52521b9.png";